/**
 * Staging — the "stage it like an open house" prop kit.
 *
 * Phase 0 ships the ownership contract and the dimensions registry only; the
 * planners and renderers come with Phase 1. See
 * claude-docs/2026-09-27-open-house-staging-design.md.
 */

const ownership = require('./ownership');
const propDims = require('./propDims');
const styles = require('./stagingStyles');
const { planStagingObjects } = require('./planStagingObjects');
const { planBathroomStaging } = require('./plan');
const { planKitchenStaging } = require('./plan/kitchen');
const { stagingKitsFor } = require('./stagingKind');
const stagedHosts = require('./stagedHosts');
const { stageRoom } = require('./stageRoom');
const { freshStagingId } = require('./freshStagingId');
const { roomFixtureSignature } = require('./fixtureSignature');
const teaTowel = require('./teaTowel');
const {
  TRAY_BASE_FRACTION,
  surfaceTopY,
  STAGING_WALL_MOUNT_HEIGHTS,
  STAGING_WALL_MOUNT_MEASURE_FROM,
} = require('./plan/constants');

module.exports = {
  ...ownership,
  ...propDims,
  ...styles,
  planStagingObjects,
  planBathroomStaging,
  planKitchenStaging,
  stagingKitsFor,
  ...stagedHosts,
  stageRoom,
  freshStagingId,
  roomFixtureSignature,
  ...teaTowel,
  TRAY_BASE_FRACTION,
  surfaceTopY,
  STAGING_WALL_MOUNT_HEIGHTS,
  STAGING_WALL_MOUNT_MEASURE_FROM,
};
